document.addEventListener('DOMContentLoaded', function () {

    const mobileBtn = document.querySelector('.js-mobile-btn');
    const btnMobile = document.querySelector('.btn-mobile');
    const menuMobile = document.querySelector('.menu-mobile');

    mobileBtn.addEventListener('click', function () {
        btnMobile.classList.toggle('click');
        menuMobile.classList.toggle('active');
    });

    const submenuBtns = document.querySelectorAll('.js-submenu-btn');
    const menuMobileSubmenus = document.querySelectorAll('.menu-mobile__submenu');

    submenuBtns.forEach(function (submenuBtn, index) {
        submenuBtn.addEventListener('click', function () {
            
            submenuBtn.classList.toggle('active');

            const currentMenuMobileSubmenu = menuMobileSubmenus[index];
            currentMenuMobileSubmenu.classList.toggle('active');

            menuMobileSubmenus.forEach((submenu, i) => {
                if (i !== index) {
                    submenu.classList.remove('active');
                    submenu.style.maxHeight = null;
                    submenuBtns[i].classList.remove('active');
                }
            });

            if (currentMenuMobileSubmenu.style.maxHeight) {
                currentMenuMobileSubmenu.style.maxHeight = null;
            } else {
                currentMenuMobileSubmenu.style.maxHeight = currentMenuMobileSubmenu.scrollHeight + "px";
            }
        });
    });

});